(function () {
  var brokenReadyToShipPath = "/collections/ready-to-ship";
  var activeReadyToShipPath = "/collections/in-stock";

  function matchesReadyToShip(value) {
    if (!value) {
      return false;
    }

    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, "") === brokenReadyToShipPath;
    } catch (error) {
      return value.replace(/\/$/, "") === brokenReadyToShipPath;
    }
  }

  function normalizeNode(node) {
    if (!node || !node.querySelectorAll) {
      return;
    }

    node.querySelectorAll("a[href]").forEach(function (link) {
      if (matchesReadyToShip(link.getAttribute("href"))) {
        link.setAttribute("href", activeReadyToShipPath);
      }
    });

    node.querySelectorAll("[data-follow-link]").forEach(function (trigger) {
      if (matchesReadyToShip(trigger.getAttribute("data-follow-link"))) {
        trigger.setAttribute("data-follow-link", activeReadyToShipPath);
      }
    });

    node.querySelectorAll("template").forEach(function (template) {
      normalizeNode(template.content);
    });

    node.querySelectorAll("*").forEach(function (element) {
      if (element.shadowRoot) {
        normalizeNode(element.shadowRoot);
      }
    });
  }

  function normalizeReadyToShipLinks() {
    normalizeNode(document);
  }

  document.addEventListener(
    "click",
    function (event) {
      var path = typeof event.composedPath === "function" ? event.composedPath() : [];
      var target = path.find(function (node) {
        return node && node.getAttribute && (node.hasAttribute("href") || node.hasAttribute("data-follow-link"));
      });

      if (!target) {
        return;
      }

      var href = target.getAttribute("href");
      var followLink = target.getAttribute("data-follow-link");

      if (matchesReadyToShip(href)) {
        target.setAttribute("href", activeReadyToShipPath);
      }

      if (matchesReadyToShip(followLink)) {
        target.setAttribute("data-follow-link", activeReadyToShipPath);
      }
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", normalizeReadyToShipLinks);
  } else {
    normalizeReadyToShipLinks();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 || node.nodeType === 11) {
          normalizeNode(node);
        }
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
